// extracted by mini-css-extract-plugin
export default {"container":"qKuhpfHqv0DrANl-dwm11w==","noBorder":"SojsBeVQnDs0fsVNBkuGYg==","tabList":"EZ7e+BXwg8cCRXw4wjx8IQ=="};